import ivyStore from "@ivy/fts/ivyStore"
import * as weixin from "@ivy/fts/weixin"
import router from "./router"
export class Store {
  footBarShow: boolean = true
  appSharePromise: any = null
  noApp: boolean = window.location.href.includes('opt=noapp')
  fromQr: boolean = window.location.href.includes('from=qr')
  logined: any = ivyStore.logined

  async login(vue, force = 0) {
    if (window.location.href.includes('for=h5')) {
      this.logined.token = ''
      return
    }
    return await ivyStore.login(vue, force)
  }
  async login2(disableOther = true) {
    return await ivyStore.login2(0, disableOther)
  }
  async bindPhone(options) {
    return await ivyStore.bindPhone(options)
  }
  async setupShare(options = {}) {
    if (!options) {
      this.appSharePromise = weixin.weixinShare({
        link: window.location.href,
        imgUrl: 'http://service.ivydad.com/tools/imagePageb90c706a-534d-130b-e518-24bbf335810a.png?x-oss-process=image/resize,w_750',
      })
    }
    await this.appSharePromise
    if (options) {
      await weixin.weixinShare(options)
    }
  }
}

export default new Store()
